import { AlertsPrimaryDarkIcon, AlertsPrimaryIcon, ChangepasswordPrimaryDarkIcon, ChangepasswordPrimaryIcon, ContactsPrimaryDarkIcon, ContactsPrimaryIcon, ConversationsPrimaryDarkIcon, ConversationsPrimaryIcon, DashboardPrimaryDarkIcon, DashboardPrimaryIcon, FalkonDocIcon, FalkonDocPrimaryIcon, FeaturesPrimaryDarkIcon, FeaturesPrimaryIcon, GroupsPrimaryDarkIcon, GroupsPrimaryIcon, OrganizationsPrimaryDarkIcon, OrganizationsPrimaryIcon, ReportsPrimaryDarkIcon, ReportsPrimaryIcon, ScheduleMessagePrimaryDarkIcon, ScheduleMessagePrimaryIcon, SecureChatActiveIcon, SecureChatGreyIcon, SettingsPrimaryDarkIcon, SettingsPrimaryIcon, TemplatesPrimaryDarkIcon, TemplatesPrimaryIcon, TiersPrimaryDarkIcon, TiersPrimaryIcon, TransferPrimaryDarkIcon, TransferPrimaryIcon, UsersPrimaryDarkIcon, UsersPrimaryIcon } from '../../icon';
import { PlanMetrics, UserPlanTracker } from '../../models/plan-metrics.model';
import { RouteModel } from "../../models/routes.model";
import { lazy } from 'react';
import { withErrorBoundaries } from '../shared/error-handler.component';
import { WebRoutes } from './route.path';
import { LocalStorage } from '../../services/UtilityService';
import store from '../../stores/app-store';
import AccountBilling from '../account-billing/Account-billing';
import AlertsComponent from '../alerts/alerts.component';
import Contacts from "../contacts/contact.component";
import ConversationComponent from '../conversations/conversation-component';
import Dashboard from "../dashboard/dashboard-view.component";
import Features from "../features/feature.component";
import Groups from "../groups";
import ForgotPassword from '../login/forgot-password.component';
import Login from '../login/login.component';
import ResetPassword from '../login/reset-password.component';
import TwofactorAuthentication from '../login/twofactor-authentication.component';
import NewOrganization from '../new-Organizations/NewOrganization';
import OrgPlanHistoryComponent from '../new-Organizations/planHistory';
import NewUsers from '../new-Users/NewUsers';
import Organization from "../organizations/organization.component";
import Changepassword from "../profile/change-password.component";
import Profile from "../profile/profile.component";
import Reports from '../reports';
import BlockedContact from '../reports/blocked-contacts.component';
import CreditLogsComponent from '../reports/credit-logs-component';
import OptOutPolicy from '../reports/optout-policy.component';
import ScheduledMessage from '../scheduled-messages/scheduled-messages.component';
import FalkonSecureChat from '../secure-chat';
import Settings from "../settings/settings.component";
import SsoInactive from '../shared/sso-inactive.component';
import Signup from '../signup';
import TemplateComponent from '../templates';
import Tiers from "../tiers/tier.component";
import Transfers from "../transfers";
import User from "../users/user.component";
import SecureDocs from '../falkon-docs/index';
import SecureDocsUploads from '../falkon-docs/falkon-docs-uploads';
import AddRecipientComponent from '../falkon-docs/add-recipients-component';
import DisplaySuccessMaessageComponent from '../falkon-docs/display-success-message.component';
import FalkonSecureDocOtp from '../falkon-docs/secure-doc-otp-verification.component';
import EndUserSigningComponent from '../falkon-docs/end-user-signing.component';
import DisplaySignerSuccessMaessageComponent from '../falkon-docs/display-signer-success-message.component';
import FalkonSignedSecureDocOtp from '../falkon-docs/signed-secure-doc-otp-verification.component';
import CompletedPDFViewerComponent from '../falkon-docs/completed-secure-doc-view.component';
import EndUserWebFormComponent from '../web-forms/end-user-webform.component';
import { LoginType } from '../../models/settings-model';

let existing_routes: RouteModel[] = [];
let user_id: string = "";

export const MobileRoutes = () => {
    const currentUser = LocalStorage.get("current-user")
    const isNewSubFlow = currentUser?.isNewSubFlow ?? false
    const userId = currentUser?.id ?? ""
    if (existing_routes?.length === 0 || user_id !== userId) {
        const routes: RouteModel[] = [
            {
                id: 1,
                label: "Dashboard",
                path: WebRoutes.DASHBOARD,
                component: withErrorBoundaries(Dashboard, "Dashboard"),
                primaryIcon: DashboardPrimaryIcon,
                primaryDarkIcon: DashboardPrimaryDarkIcon,
                roles: [2, 3, 4],
                authenticationRequired: true,
                isSideMenu: true
            },
            // {
            // 	id: 2,
            // 	label: "Plans",
            // 	path: WebRoutes.PLANS,
            // 	component: withErrorBoundaries(PlansComponent),
            // 	primaryIcon: PlansPrimaryIcon,
            // 	primaryDarkIcon: PlansPrimaryDarkIcon,
            // 	secondaryIcon: PlansPrimaryIcon,
            // 	roles: [2],
            // 	authenticationRequired: true,
            // 	isSideMenu: true
            // },
            {
                id: 3,
                label: "Organizations",
                path: WebRoutes.ORGANIZATIONS,
                component: withErrorBoundaries(Organization, "Organization"),
                primaryIcon: OrganizationsPrimaryIcon,
                primaryDarkIcon: OrganizationsPrimaryDarkIcon,
                roles: [1],
                authenticationRequired: true,
                isSideMenu: true
            },
            // {
            // 	id: 4,
            // 	label: "Phone Numbers",
            // 	path: WebRoutes.PHONE_NUMBERS,
            // 	component: withErrorBoundaries(PhoneNumber, "PhoneNumber"),
            // 	primaryIcon: PhoneNumbersPrimaryIcon,
            // 	primaryDarkIcon: PhoneNumbersPrimaryDarkIcon,
            // 	secondaryIcon: PhoneNumbersPrimaryIcon,
            // 	roles: [1],
            // 	authenticationRequired: true,
            // 	isSideMenu: true
            // },
            {
                id: 5,
                label: "Users",
                path: isNewSubFlow ? WebRoutes.NEW_USERS : WebRoutes.USERS,
                component: withErrorBoundaries(isNewSubFlow ? NewUsers : User, "Users"),
                primaryIcon: UsersPrimaryIcon,
                primaryDarkIcon: UsersPrimaryDarkIcon,
                roles: [1, 2, 4],
                authenticationRequired: true,
                isSideMenu: true
            },
            {
                id: 6,
                label: "Conversations",
                path: `${WebRoutes.CONVERSATIONS}/*`,
                component: withErrorBoundaries(ConversationComponent, "Conversations"),
                primaryIcon: ConversationsPrimaryIcon,
                primaryDarkIcon: ConversationsPrimaryDarkIcon,
                roles: [2, 3, 4],
                authenticationRequired: true,
                isSideMenu: true,
                highlightDataKey: "unreadMessageCount",
                enableHighlight: true,
                hasSubRoutes: false,
                exact: true,
            },
            {
                id: 102,
                label: "Secure Chat",
                path: `${WebRoutes.SECURE_CONVERSATIONS}/*`,
                component: withErrorBoundaries(ConversationComponent, "Conversations"),
                primaryIcon: SecureChatGreyIcon,
                primaryDarkIcon: SecureChatActiveIcon,
                roles: [2, 3, 4],
                authenticationRequired: true,
                isSideMenu: true,
                highlightDataKey: "secureChatUnReadMessageCount",
                enableHighlight: true,
                hasSubRoutes: false,
                exact: true,
                PlanFilter: "HasAccessToSecureChat",
            },
            {
                id: 7,
                label: "Scheduled Messages",
                path: WebRoutes.SCHEDULED_MESSAGES,
                component: withErrorBoundaries(ScheduledMessage, "ScheduledMessage"),
                primaryIcon: ScheduleMessagePrimaryIcon,
                primaryDarkIcon: ScheduleMessagePrimaryDarkIcon,
                roles: [2, 3, 4],
                authenticationRequired: true,
                isSideMenu: true,
                enableHighlight: true,
                PlanFilter: "HasMessageScheduling"
            },
            {
                id: 8,
                label: "Contacts",
                path: WebRoutes.CONTACTS,
                component: withErrorBoundaries(Contacts, "Contacts"),
                primaryIcon: ContactsPrimaryIcon,
                primaryDarkIcon: ContactsPrimaryDarkIcon,
                roles: [2, 3, 4],
                authenticationRequired: true,
                isSideMenu: true
            },
            {
                id: 9,
                label: "Groups (Campaigns)",
                path: WebRoutes.GROUPS,
                component: withErrorBoundaries(Groups, "Groups"),
                primaryIcon: GroupsPrimaryIcon,
                primaryDarkIcon: GroupsPrimaryDarkIcon,
                roles: [2, 3, 4],
                authenticationRequired: true,
                isSideMenu: true,
                PlanFilter: isNewSubFlow ? "HasGroupBroadcast" : ""
            },
            {
                id: 10,
                label: "Transfer Credits",
                path: WebRoutes.TRANSFERS,
                component: withErrorBoundaries(Transfers, "Transfers"),
                roles: [2, 3, 4],
                primaryIcon: TransferPrimaryIcon,
                primaryDarkIcon: TransferPrimaryDarkIcon,
                authenticationRequired: true,
                isSideMenu: false,
                isUserMenu: true,
                hide: isNewSubFlow
            },
            {
                id: 11,
                label: "Settings",
                path: `${WebRoutes.SETTINGS}`,
                component: withErrorBoundaries(Settings, "Settings"),
                primaryIcon: SettingsPrimaryIcon,
                primaryDarkIcon: SettingsPrimaryDarkIcon,
                roles: [1, 2, 3, 4],
                authenticationRequired: true,
                isSideMenu: false,
                isUserMenu: true,
                exact: true
            },
            // {
            //     id: 12,
            //     label: "Switch Phone Number",
            //     path: WebRoutes.SWITCH_PHONE_NUMBER,
            //     component: withErrorBoundaries(SwitchPhoneNumber, "SwitchPhoneNumber"),
            //     primaryIcon: SwitchPhoneNumberPrimaryIcon,
            //     primaryDarkIcon: SwitchPhoneNUmberPrimaryDarkIcon,
            //     roles: [2],
            //     authenticationRequired: true,
            //     isSideMenu: false,
            //     isUserMenu: true
            // },
            // {
            //     id: 13,
            //     label: "Kafka Cluster",
            //     path: WebRoutes.KAFKA_CLUSTER,
            //     component: withErrorBoundaries(KafkaComponent, "Kafka Cluster"),
            //     primaryIcon: KafkaPrimaryIcon,
            //     primaryDarkIcon: KafkaPrimaryDarkIcon,
            //     roles: [1],
            //     authenticationRequired: true,
            //     isSideMenu: false,
            //     isUserMenu: true
            // },
            {
                id: 14,
                label: "Change Password",
                path: WebRoutes.CHANGE_PASSWORD,
                component: withErrorBoundaries(Changepassword, "Changepassword"),
                primaryIcon: ChangepasswordPrimaryIcon,
                primaryDarkIcon: ChangepasswordPrimaryDarkIcon,
                roles: [1, 2, 3, 4],
                authenticationRequired: true,
                isSideMenu: false,
                isUserMenu: true
            },
            {
                id: 15,
                label: "Profile",
                path: WebRoutes.PROFILE,
                component: withErrorBoundaries(Profile, "Profile"),
                roles: [1, 2, 3, 4],
                authenticationRequired: true,
                isSideMenu: false
            },
            {
                id: 16,
                label: "Plans",
                path: WebRoutes.TIERS,
                component: withErrorBoundaries(Tiers, "Plans"),
                primaryIcon: TiersPrimaryIcon,
                primaryDarkIcon: TiersPrimaryDarkIcon,
                roles: [1],
                authenticationRequired: true,
                isSideMenu: true
            },
            {
                id: 17,
                label: "Features",
                path: WebRoutes.FEATURES,
                component: withErrorBoundaries(Features, "Features"),
                primaryIcon: FeaturesPrimaryIcon,
                primaryDarkIcon: FeaturesPrimaryDarkIcon,
                roles: [1],
                authenticationRequired: true,
                isSideMenu: true
            },
            // {
            // 	id: 18,
            // 	label: "",
            // 	path: WebRoutes.ADD_PHONE_NUMBER,
            // 	component: withErrorBoundaries(AddPhoneNumber),
            // 	roles: [1, 2],
            // 	authenticationRequired: true,
            // 	isSideMenu: false
            // },
            // {
            // 	id: 19,
            // 	label: "",
            // 	path: WebRoutes.PAYMENT_STATUS,
            // 	component: withErrorBoundaries(PaymentStatusComponent),
            // 	roles: [1, 2],
            // 	authenticationRequired: true,
            // 	isSideMenu: false
            // },
            // {
            // 	id: 20,
            // 	label: "",
            // 	path: WebRoutes.RECHARGE,
            // 	component: withErrorBoundaries(Recharge),
            // 	roles: [1, 2],
            // 	authenticationRequired: true,
            // 	isSideMenu: false
            // },
            {
                id: 21,
                label: "Alerts",
                path: WebRoutes.ALERTS,
                component: withErrorBoundaries(AlertsComponent, "AlertsComponent"),
                primaryIcon: AlertsPrimaryIcon,
                primaryDarkIcon: AlertsPrimaryDarkIcon,
                roles: [1],
                authenticationRequired: true,
                isSideMenu: true
            },
            // {
            // 	id: 22,
            // 	label: "",
            // 	path: WebRoutes.REHOST,
            // 	component: withErrorBoundaries(RehostComponent),
            // 	roles: [1, 2],
            // 	authenticationRequired: true,
            // 	isSideMenu: false
            // },
            // {
            // 	id: 23,
            // 	label: "Automation Rules",
            // 	path: WebRoutes.AUTOMATION_RULES,
            // 	component: withErrorBoundaries(AutoAlertRules),
            // 	roles: [2, 3],
            // 	primaryIcon: AutomationPrimaryIcon,
            // 	primaryDarkIcon: AutomationPrimaryDarkIcon,
            // 	secondaryIcon: AutomationPrimaryIcon,
            // 	authenticationRequired: true,
            // 	isSideMenu: true,
            // 	hasSubRoutes: true,
            // 	PlanFilter: "HasAccessAutoReplies",
            // 	children: [{
            // 		id: 1,
            // 		label: "Automation Rules",
            // 		subRouteLabel: "Rules",
            // 		path: WebRoutes.AUTOMATION_RULES,
            // 		component: withErrorBoundaries(AutoAlertRules),
            // 		roles: [2, 3],
            // 		authenticationRequired: true,
            // 		isSideMenu: true
            // 	},
            // 	{
            // 		id: 2,
            // 		label: "Automation Rules - Keywords",
            // 		subRouteLabel: "Keywords",
            // 		path: WebRoutes.AUTOMATION_KEYWORD,
            // 		component: withErrorBoundaries(AutoAlertKeyword),
            // 		roles: [2, 3],
            // 		authenticationRequired: true,
            // 		isSideMenu: true

            // 	},
            // 	{
            // 		id: 3,
            // 		label: "Automation Rules - Logs",
            // 		subRouteLabel: "Logs",
            // 		path: WebRoutes.AUTOMATION_LOGS,
            // 		component: withErrorBoundaries(AutoAlertLogs),
            // 		roles: [2, 3],
            // 		authenticationRequired: true,
            // 		isSideMenu: true
            // 	}
            // 	]
            // },
            // {
            //     id: 23,
            //     label: "Falkon Sign",
            //     path: WebRoutes.FALKON_DOCS,
            //     component: withErrorBoundaries(SecureDocs, "Falkon Sign"),
            //     primaryIcon: FalkonDocPrimaryIcon,
            //     primaryDarkIcon: FalkonDocIcon,
            //     roles: [2, 3],
            //     authenticationRequired: true,
            //     isSideMenu: true,
            //     exact: true,
            //     PlanFilter: "HasAccessToSecureDoc",
            // },
            {
                id: 24,
                label: "Templates",
                path: WebRoutes.TEMPLATES,
                component: withErrorBoundaries(TemplateComponent, "TemplateComponent"),
                primaryIcon: TemplatesPrimaryIcon,
                primaryDarkIcon: TemplatesPrimaryDarkIcon,
                roles: [2, 3, 4],
                authenticationRequired: true,
                isSideMenu: true
            },

            // {
            //     id: 25,
            //     label: "Reports",
            //     path: WebRoutes.REPORTS,
            //     component: withErrorBoundaries(Reports, "Reports"),
            //     primaryIcon: ReportsPrimaryIcon,
            //     primaryDarkIcon: ReportsPrimaryDarkIcon,
            //     roles: [2, 3],
            //     authenticationRequired: true,
            //     isSideMenu: true
            // },
            {
                id: 30,
                label: "Conversations",
                path: WebRoutes.CONVERSATION_HISTORY,
                component: withErrorBoundaries(ConversationComponent, "Conversations"),
                primaryIcon: ConversationsPrimaryIcon,
                primaryDarkIcon: ConversationsPrimaryDarkIcon,
                roles: [2, 3, 4],
                authenticationRequired: true,
                isSideMenu: false,
                highlightDataKey: "unreadMessageCount",
                enableHighlight: true,
                exact: true
            },
            // {
            //     id: 31,
            //     label: "Reports",
            //     path: WebRoutes.REPORTS,
            //     component: withErrorBoundaries(Reports, "Reports"),
            //     roles: [3],
            //     primaryIcon: ReportsPrimaryIcon,
            //     primaryDarkIcon: ReportsPrimaryDarkIcon,
            //     authenticationRequired: true,
            //     isSideMenu: true,
            // },
            {
                id: 32,
                label: "Reports",
                path: WebRoutes.REPORTS,
                component: withErrorBoundaries(Reports, "Reports"),
                roles: [2, 4],
                primaryIcon: ReportsPrimaryIcon,
                primaryDarkIcon: ReportsPrimaryDarkIcon,
                authenticationRequired: true,
                isSideMenu: true,
                hasSubRoutes: true,
                children: [{
                    id: 1,
                    label: "Broadcast & Schedule Logs",
                    subRouteLabel: "Schedule-broadcast-logs",
                    path: WebRoutes.REPORTS,
                    component: withErrorBoundaries(Reports, "Reports"),
                    roles: [1, 2, 3, 4],
                    authenticationRequired: true,
                    isSideMenu: true
                },
                {
                    id: 2,
                    label: "Credit Logs",
                    subRouteLabel: "Credit Logs",
                    path: WebRoutes.CreditLog,
                    component: withErrorBoundaries(CreditLogsComponent, "Reports - Credit Logs"),
                    roles: [1, 2, 3, 4],
                    authenticationRequired: true,
                    isSideMenu: true,
                    hide: isNewSubFlow
                },
                {
                    id: 4,
                    label: "Opt-Out List",
                    subRouteLabel: "Opt-Out List",
                    path: WebRoutes.OPTOUT_POLICY,
                    component: withErrorBoundaries(OptOutPolicy, "Opt-Out List"),
                    roles: [2, 3, 4],
                    authenticationRequired: true,
                    isSideMenu: true
                },
                {
                    id: 5,
                    label: "Blocked List",
                    subRouteLabel: "Blocked List",
                    path: WebRoutes.BLOCKED_CONTACTS_LIST,
                    component: withErrorBoundaries(BlockedContact, "Blocked List"),
                    roles: [2, 3, 4],
                    authenticationRequired: true,
                    isSideMenu: true,
                    hide: isNewSubFlow ? "HasBlockList" : false
                },
                ].filter(x => isNewSubFlow ? !x.hide === isNewSubFlow : x)
            },
            // {
            //     id: 33,
            //     label: "",
            //     path: WebRoutes.SCHEDULED_REPORT,
            //     component: withErrorBoundaries(scheduledReportComponent, "scheduled report"),
            //     roles: [2],
            //     authenticationRequired: true,
            //     isSideMenu: false,
            //     exact: true
            // },
            {
                id: 51,
                label: "Falkon Sign",
                path: WebRoutes.FALKON_DOCS_UPLOADS,
                component: withErrorBoundaries(SecureDocsUploads, "Falkon Sign Uploads"),
                primaryIcon: FalkonDocPrimaryIcon,
                primaryDarkIcon: FalkonDocIcon,
                roles: [2, 3],
                authenticationRequired: true,
                isSideMenu: false,
                exact: true
            },
            {
                id: 52,
                label: "",
                path: WebRoutes.FALKON_DOCS_SUCCESS,
                component: withErrorBoundaries(DisplaySuccessMaessageComponent, "Falkon Sign Configure Success"),
                roles: [2, 3],
                authenticationRequired: true,
                isSideMenu: false,
            },
            {
                id: 53,
                label: "",
                path: WebRoutes.FALKON_DOCS_OTP,
                component: withErrorBoundaries(FalkonSecureDocOtp, "Falkon Sign Otp"),
                roles: [2, 3],
                authenticationRequired: false,
                isSideMenu: false,
            },
            {
                id: 54,
                label: "",
                path: WebRoutes.FALKON_DOCS_END_USER_SIGN,
                component: withErrorBoundaries(EndUserSigningComponent, "Falkon Sign End User Sign"),
                roles: [2, 3],
                authenticationRequired: false,
                isSideMenu: false,
            },
            {
                id: 55,
                label: "",
                path: WebRoutes.FALKON_DOCS_END_USER_SIGN_SUCCESS,
                component: withErrorBoundaries(DisplaySignerSuccessMaessageComponent, "Falkon Sign End User Sign Success"),
                roles: [2, 3],
                authenticationRequired: false,
                isSideMenu: false,
            },
            {
                id: 56,
                label: "",
                path: WebRoutes.FALKON_DOCS_VERIFY_OTP,
                component: withErrorBoundaries(FalkonSignedSecureDocOtp, "Falkon Sign End User Verify OTP"),
                roles: [2, 3],
                authenticationRequired: false,
                isSideMenu: false,
            },
            {
                id: 57,
                label: "",
                path: WebRoutes.FALKON_DOCS_COMPLETED,
                component: withErrorBoundaries(CompletedPDFViewerComponent, "Completed Falkon Sign"),
                roles: [2, 3],
                authenticationRequired: false,
                isSideMenu: false,
            },
            {
                id: 1111,
                label: "Login",
                path: WebRoutes.SIGN_IN,
                component: withErrorBoundaries(Login, "Login"),
                roles: [1, 2, 3, 4],
                authenticationRequired: false,
                isSideMenu: false,
            },
            {
                id: 1112,
                label: "SignUp",
                path: WebRoutes.SIGN_UP,
                component: withErrorBoundaries(Signup, "signup"),
                roles: [1, 2, 3, 4],
                authenticationRequired: false,
                isSideMenu: false,
            },
            {
                id: 1113,
                label: "2FA",
                path: WebRoutes.SIGN_UP,
                component: withErrorBoundaries(TwofactorAuthentication, "2FA"),
                roles: [1, 2, 3, 4],
                authenticationRequired: false,
                isSideMenu: false,
            },
            {
                id: 1114,
                label: "Forgot Password",
                path: WebRoutes.SIGN_UP,
                component: withErrorBoundaries(ForgotPassword, "forgotPassword"),
                roles: [1, 2, 3, 4],
                authenticationRequired: false,
                isSideMenu: false,
            },
            {
                id: 1115,
                label: "Rest Password",
                path: WebRoutes.RESET_PASSWORD_NEW,
                component: withErrorBoundaries(ResetPassword, "resetPassword"),
                roles: [1, 2, 3, 4],
                authenticationRequired: false,
                isSideMenu: false,
            },
            {
                id: 1116,
                label: "SSO Error",
                path: WebRoutes.SSO_ERROR_PAGE,
                component: withErrorBoundaries(SsoInactive, "ssoError"),
                roles: [1, 2, 3, 4],
                authenticationRequired: false,
                isSideMenu: false,
            },
            {
                id: 1119,
                label: "Falkon Secure Chat",
                path: WebRoutes.FALKON_SECURE_CHAT,
                component: withErrorBoundaries(FalkonSecureChat, "Falkon Secure Chat"),
                roles: [1, 2, 3, 4],
                authenticationRequired: false,
                isSideMenu: false,
            },
            {
                id: 1120,
                label: "New Organizations",
                path: WebRoutes.NEW_ORGANIZATION,
                component: withErrorBoundaries(NewOrganization, "New Organizations"),
                primaryIcon: OrganizationsPrimaryIcon,
                primaryDarkIcon: OrganizationsPrimaryDarkIcon,
                roles: [1],
                authenticationRequired: true,
                isSideMenu: true
            },
            {
                id: 1121,
                label: "New Users",
                path: WebRoutes.NEW_USERS,
                component: withErrorBoundaries(NewUsers, "New Users"),
                primaryIcon: UsersPrimaryIcon,
                primaryDarkIcon: UsersPrimaryDarkIcon,
                roles: [1],
                authenticationRequired: true,
                isSideMenu: true
            },
            {
                id: 1122,
                label: "Seat History",
                path: WebRoutes.ORGANIZATION_PLAN_HISTORY,
                component: withErrorBoundaries(OrgPlanHistoryComponent, "Seat-history"),
                primaryIcon: ContactsPrimaryIcon,
                primaryDarkIcon: ContactsPrimaryDarkIcon,
                // secondaryIcon: ContactsPrimaryIcon,
                roles: [1],
                authenticationRequired: true,
                isSideMenu: false,
                exact: true
            },
            {
                id: 1123,
                label: "Account & Billing",
                path: `${WebRoutes.ACCOUNT_BILLING}`,
                component: withErrorBoundaries(AccountBilling, "Account Billing"),
                primaryIcon: TemplatesPrimaryIcon,
                primaryDarkIcon: TemplatesPrimaryDarkIcon,
                roles: [2, 3],
                authenticationRequired: true,
                isSideMenu: true,
                hide: true
            },
            {
                id: 1124,
                label: "Web Form",
                path: WebRoutes.WEB_FORM_END_USER_VIEW,
                component: withErrorBoundaries(EndUserWebFormComponent, "Web Form redirect"),
                roles: [2, 3, 4],
                authenticationRequired: false,
                isSideMenu: false
            }
        ].filter(x => !x.hide);

        existing_routes = routes;
        user_id = userId;
    }
    return existing_routes
}

export const getAuthorisedRoutes = (role: number, planMetrics: PlanMetrics | UserPlanTracker): RouteModel[] => {
    return MobileRoutes().filter(route => route.authenticationRequired && (!planMetrics || !route.PlanFilter || !!planMetrics[route.PlanFilter || ""]) && route.roles.includes(role))
}

export const getSideMenus = (role: number, planMetrics: PlanMetrics | UserPlanTracker): RouteModel[] => {
    return MobileRoutes().filter(route => route.isSideMenu && (!planMetrics || !route.PlanFilter || !!planMetrics[route.PlanFilter || ""]) && route.roles.includes(role))
}

export const getUserMenus = (role: number, planMetrics: PlanMetrics | UserPlanTracker): RouteModel[] => {
    let routes = MobileRoutes();
    const OrganizationLoginType = store.getState().OrganizationLoginType;
    if (OrganizationLoginType.SSOType !== LoginType.None) {
        routes = MobileRoutes().filter(x => x.label !== "Change Password")
    }
    return routes.filter(route => route.isUserMenu && (!planMetrics || !route.PlanFilter || !!planMetrics[route.PlanFilter || ""]) && route.roles.includes(role))
}

export const getUnAuthorisedRoutes = (): RouteModel[] => {
    return MobileRoutes().filter(route => !route.authenticationRequired)
}